(function (jQuery) {
  jQuery.gfBorderWidth = function (element, options) {
    const defaults = {
      onSelected: function (value) {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.gfInputField();
      const $gfBorderWidth = $element.next('.gfInputField');
      const $gfInputFieldBox = $element.next('.gfInputField');
      const $gfInputFieldBoxInput = $gfInputFieldBox.find('input');

      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      const $targetElement = $gryffBody.find('#' + merId);

      $gfBorderWidth
        .find('input')
        .off('mousedown.Borderwidth')
        .on('mousedown.Borderwidth', function (e) {
          let $that = jQuery(this),
            start = e.pageY,
            end,
            old = parseInt($that.val()) || 0;

          $gfLeftSideBar.css('cursor', 'ns-resize').on('mousemove.Borderwidth', function (e) {
            end = e.pageY;
            let newVar = old + Math.floor((start - end) / 2);
            if (newVar < 0) {
              newVar = 0;
            }
            $gfBorderWidth.find('input').val(newVar);
            $element
              .attr('value', newVar + $element.data('gfinputfield').getCurrentUnit())
              .val(newVar + $element.data('gfinputfield').getCurrentUnit())
              .trigger('value-change')
              .trigger('input-change');
          });
          $gfLeftSideBar.on('mouseup.left', function (e) {
            $gfLeftSideBar.css('cursor', 'default').off('mouseup.Borderwidth');
            $gfLeftSideBar.css('cursor', 'default').off('mousemove.Borderwidth');
          });
        });
      $gfInputFieldBox
        .find('input')
        .off('keyup change paste')
        .on('keyup change paste', function () {
          const $that = jQuery(this);
          let value = $that.val();
          if (value < 0) {
            value = 0;
          }
          $gfInputFieldBoxInput.val(value);
          $element.attr('value', value).val(value).trigger('value-change').trigger('input-change');
        });
      return false;
    };

    this.applyEvents = function () {
      return false;
    };

    this.init();
  };
  jQuery.fn.gfBorderWidth = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfborderwidth')) {
        const plugin = new jQuery.gfBorderWidth(this, options);
        jQuery(this).data('gfborderwidth', plugin);
      }
    });
  };
})(jQuery);
